'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  border: 0px solid transparent;\n  box-sizing: border-box;\n  ', '\n  ', '\n  ', '\n'], ['\n  display: flex;\n  border: 0px solid transparent;\n  box-sizing: border-box;\n  ', '\n  ', '\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-grow: 1;\n  flex-direction: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  box-sizing: border-box;\n'], ['\n  display: flex;\n  flex-grow: 1;\n  flex-direction: ', ';\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  ', '\n  box-sizing: border-box;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _alignments = require('../../constants/alignments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContainerPush = _styledComponents2.default.div(_templateObject, function (_ref) {
  var fullSize = _ref.fullSize;
  return fullSize && 'min-height: 100%; min-width: 100%;';
}, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth && 'min-width: 100%;';
}, function (_ref3) {
  var fullHeight = _ref3.fullHeight;
  return fullHeight && 'min-height: 100%;';
});

var ContainerComponent = _styledComponents2.default.div(_templateObject2, function (_ref4) {
  var inline = _ref4.inline;
  return inline ? 'row' : 'column';
}, function (_ref5) {
  var verticalAlignment = _ref5.verticalAlignment,
      inline = _ref5.inline;
  return verticalAlignment === _alignments.Alignments.center && (inline ? "align-items: center;" : "justify-content: center;");
}, function (_ref6) {
  var verticalAlignment = _ref6.verticalAlignment,
      inline = _ref6.inline;
  return verticalAlignment === _alignments.Alignments.bottom && (inline ? "align-items: flex-end;" : "justify-content: flex-end;");
}, function (_ref7) {
  var horizontalAlignment = _ref7.horizontalAlignment,
      inline = _ref7.inline;
  return horizontalAlignment === _alignments.Alignments.left && (inline ? "justify-content: left;" : "align-items: left;");
}, function (_ref8) {
  var horizontalAlignment = _ref8.horizontalAlignment,
      inline = _ref8.inline;
  return horizontalAlignment === _alignments.Alignments.center && (inline ? "justify-content: center;" : "align-items: center;");
}, function (_ref9) {
  var horizontalAlignment = _ref9.horizontalAlignment,
      inline = _ref9.inline;
  return horizontalAlignment === _alignments.Alignments.right && (inline ? "justify-content: flex-end;" : "align-items: flex-end;");
}, function (_ref10) {
  var color = _ref10.color;
  return color && 'background-color: ' + color + ';';
}, function (_ref11) {
  var top = _ref11.top;
  return 'margin-top: ' + top + 'px;';
}, function (_ref12) {
  var bottom = _ref12.bottom;
  return 'margin-bottom: ' + bottom + 'px;';
}, function (_ref13) {
  var left = _ref13.left;
  return 'margin-left: ' + left + 'px;';
}, function (_ref14) {
  var right = _ref14.right;
  return 'margin-right: ' + right + 'px;';
});

var Container = function (_React$Component) {
  _inherits(Container, _React$Component);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  _createClass(Container, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        ContainerPush,
        { fullSize: this.props.fullSize,
          fullWidth: this.props.fullWidth,
          fullHeight: this.props.fullHeight
        },
        _react2.default.createElement(
          ContainerComponent,
          {
            inline: this.props.inline,
            verticalAlignment: this.props.verticalAlignment,
            horizontalAlignment: this.props.horizontalAlignment,
            fullSize: this.props.fullSize,
            color: this.props.color,
            onClick: this.props.clickEvent,
            onMouseEnter: this.props.mouseEnterEvent,
            onMouseLeave: this.props.mouseLeaveEvent,
            onTouchStart: this.props.touchStartEvent,
            onTouchEnd: this.props.touchEndEvent,
            draggable: this.props.draggable,
            onDragEnter: this.props.dragEnterEvent,
            onDragLeave: this.props.dragLeaveEvent,
            onDragStart: this.props.dragStartEvent,
            onDragEnd: this.props.dragEndEvent,
            onDragOver: this.props.dragOverEvent,
            onDrop: this.props.dropEvent,
            onBlur: this.props.blurEvent,
            className: this.props.className,
            top: (0, _getSize2.default)(this.props.top),
            bottom: (0, _getSize2.default)(this.props.bottom),
            left: (0, _getSize2.default)(this.props.left),
            right: (0, _getSize2.default)(this.props.right)
          },
          this.props.children
        )
      );
    }
  }]);

  return Container;
}(_react2.default.Component);

exports.default = Container;